export default "__VITE_ASSET__DoshaT$r__"